











































































































import { SubscriptionListVue } from "fs-pb-vue2/vueModels/subscription/SubscriptionListVue";
import SubscriptionEdit from "./SubscriptionEdit.vue";
import { Component } from "vue-property-decorator";
import BackLink from "@/components/app/BackLink.vue";
import i18n from "@/i18n";

@Component({
  components: {
    SubscriptionEdit,
    BackLink
  }
})
export default class SubscriptionList extends SubscriptionListVue {
  isModalOpen: boolean = false;
  selectedSub: any = null;

  openModal(sub: any): void {
    this.isModalOpen = true;
    this.selectedSub = sub;
  }

  remove(): void {
    if (this.selectedSub && this.selectedSub.Id) {
      this.deleteSub(this.selectedSub);
      this.isModalOpen = false;
    }
  }

  handleNo(): void {
    this.isModalOpen = false;
  }

  openList(): void {
    this.$router.push({ path: '/subscriptionEdit', query: { openCategorySelect: 'true' } });
  }

  getCategoryOrCaption(sub: any): string {
    if (!sub) return "";
    return sub.Document?.Type?.Category?.trim()
      ? sub.Document.Name
      : sub.Caption;
  }

  isNotUserSubscription(sub: any): boolean {
    return sub.Id !== 0 && (!sub.Document?.Number || sub.Document.Number.trim() === "");
  }

  getDescription(sub: any): string {
    if (!sub) return "";

    const typeName = sub.Document?.Type?.Category || "";
    const documentName = sub.Document?.Type?.DisplayName || "";
    const documentNumber = sub.Document?.Number || "";

    return this.isNotUserSubscription(sub)
      ? sub.Description
      : `${typeName}\n${documentName}: ${documentNumber}`;
  }
}
